var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhysicalItemColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7008_1045",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7008_1045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.37501 16.3077V10.3589L4.16667 7.34291V13.1475C4.16667 13.1901 4.17737 13.2302 4.19876 13.2677C4.22014 13.3051 4.25216 13.3371 4.2948 13.3637L9.37501 16.3077ZM10.625 16.3077L15.7052 13.3637C15.7479 13.3371 15.7799 13.3051 15.8013 13.2677C15.8226 13.2302 15.8333 13.1901 15.8333 13.1475V7.34291L10.625 10.3589V16.3077ZM9.24688 17.6714L3.67001 14.4614C3.43278 14.3248 3.24792 14.1421 3.11542 13.9135C2.98292 13.6848 2.91667 13.4337 2.91667 13.1602V6.83978C2.91667 6.56631 2.98292 6.3152 3.11542 6.08645C3.24792 5.85784 3.43278 5.6752 3.67001 5.53853L9.24688 2.32853C9.48396 2.19173 9.73501 2.12332 10 2.12332C10.265 2.12332 10.516 2.19173 10.7531 2.32853L16.33 5.53853C16.5672 5.6752 16.7521 5.85784 16.8846 6.08645C17.0171 6.3152 17.0833 6.56631 17.0833 6.83978V13.1602C17.0833 13.4337 17.0171 13.6848 16.8846 13.9135C16.7521 14.1421 16.5672 14.3248 16.33 14.4614L10.7531 17.6714C10.516 17.8083 10.265 17.8767 10 17.8767C9.73501 17.8767 9.48396 17.8083 9.24688 17.6714ZM13.2131 7.41666L15.1458 6.3077L10.1281 3.40541C10.0855 3.37874 10.0428 3.3654 10 3.3654C9.95723 3.3654 9.91452 3.37874 9.87188 3.40541L8.06251 4.44707L13.2131 7.41666ZM10 9.28207L11.9375 8.1602L6.79167 5.18582L4.85417 6.3077L10 9.28207Z",
    fill: "#796F15"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhysicalItemColored);
export default __webpack_public_path__ + "static/media/icon-physical-item-colored.771525b954d8f3082f6ea2f222788041.svg";
export { ForwardRef as ReactComponent };